"use client";
const COLORS = [
    { bg: '#B5D4F4', text: '#0C447C' },
    { bg: '#C0DD97', text: '#27500A' },
    { bg: '#F5C4B3', text: '#712B13' },
    { bg: '#F4C0D1', text: '#72243E' },
    { bg: '#CECBF6', text: '#3C3489' },
];

const SIZE_MAP = {
    sm: { size: 30, fontSize: 10, offset: -9, border: 2 },
    md: { size: 40, fontSize: 13, offset: -12, border: 2.5 },
    lg: { size: 52, fontSize: 16, offset: -16, border: 3 },
};

function getInitials(name) {
    return name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();
}

export default function AvatarGroup({
                                        users = [],
                                        max = 4,
                                        size = 'md',
                                        showTooltip = true,
                                    }) {
    const { size: px, fontSize, offset, border } = SIZE_MAP[size];
    const visible = users.slice(0, max);
    const extra = users.length - max;

    const avatarBase = {
        width: px,
        height: px,
        borderRadius: '50%',
        border: `${border}px solid white`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize,
        fontWeight: 500,
        position: 'relative',
        cursor: 'pointer',
        transition: 'transform 0.15s ease',
        flexShrink: 0,
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            {visible.map((user, i) => {
                const color = COLORS[i % COLORS.length];
                return (
                    <div
                        key={user.id ?? i}
                        title={showTooltip ? user.name : undefined}
                        style={{
                            ...avatarBase,
                            marginLeft: i === 0 ? 0 : offset,
                            background: color.bg,
                            color: color.text,
                            zIndex: visible.length - i,
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-4px)')}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'none')}
                    >
                        {user.image ? (
                            <img
                                src={user.image}
                                alt={user.name}
                                style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }}
                            />
                        ) : (
                            getInitials(user.name)
                        )}
                    </div>
                );
            })}

            {extra > 0 && (
                <div
                    style={{
                        ...avatarBase,
                        marginLeft: offset,
                        background: '#f1efe8',
                        color: '#5f5e5a',
                        zIndex: 0,
                    }}
                >
                    +{extra}
                </div>
            )}
        </div>
    );
}